import script from "./chat-popover.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-popover.vue?vue&type=script&setup=true&lang=js"

import "./chat-popover.vue?vue&type=style&index=0&id=fc9e8dae&lang=scss"

const __exports__ = script;

export default __exports__